import { actions } from './orderColumn/actions'
import { getters } from './orderColumn/getters'
import { state } from './orderColumn/state'
import { mutations } from './orderColumn/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
